import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

interface INullableBooleanProps extends ITranslateProps {
    value?: undefined | boolean;
    useSymbols?: undefined | boolean;
}

class NullableBooleanComponent extends React.Component<INullableBooleanProps, Record<string, unknown>> {
    public override render() {
        if (this.props.value === undefined) {
            return null;
        }
        if (this.props.useSymbols) {
            return <>{this.props.value ? <span className="fa fa-check"></span> : null}</>;
        }
        return <span>{this.props.value ? this.props.t('common.yes') : this.props.t('common.no')}</span>;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const NullableBoolean = translate()(NullableBooleanComponent);
export { NullableBoolean };
